import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProfile } from 'services/auth.service';

export const getAccountDetailAction = createAsyncThunk(
  'common/getAccountDetailAction',
  async () => {
    const response = await getProfile();

    return response.data;
  },
);
